import { AGE_OPTIONS } from "../constants/AgeOptions";

// AGE_OPTIONS values are range midpoints, so the bounds come from the label ("21-25", "78-89+").
// An unknown value matches everything, so a stale filter never hides the whole list.
export function ageInRange(age, value) {
  const option = AGE_OPTIONS.find((o) => o.value === value);
  if (!option) return true;
  const [minLabel, maxLabel] = option.label.split("-");
  const min = parseInt(minLabel, 10);
  const max = maxLabel.endsWith("+") ? Infinity : parseInt(maxLabel, 10);
  const n = Number(age);
  return n >= min && n <= max;
}
